import ky from 'ky';
import { clone } from 'lodash-es';

export default {
  namespace: true,
  state: {
    vehicleVocations: [
      { name: 'All Vocations', code: 'all' },
      { name: 'Freight', code: '1' },
      { name: 'Freight-Local', code: '2' },
      { name: 'Freight-Long Haul', code: '3' },
      { name: 'Nonroad-Airport', code: '5' },
      { name: 'Nonroad-CHE', code: '6' },
      { name: 'Passenger-School', code: '7' },
      { name: 'Passenger-Shuttle', code: '8' },
      { name: 'Passenger-Transit', code: '9' },
      { name: 'Service-Construction', code: '10' },
      { name: 'Service-Other', code: '11' },
      { name: 'Service-Road Maintenance', code: '12' },
      { name: 'Service-Sanitation', code: '13' },
      { name: 'Service-Utility', code: '14' },
    ],
    vehicleClasses: [
      { name: 'All Classes', code: 'all' },
      { name: 'Unknown', code: '-1' },
      { name: 'Class 1', code: '1' },
      { name: 'Class 2', code: '2' },
      { name: 'Class 3', code: '3' },
      { name: 'Class 4', code: '4' },
      { name: 'Class 5', code: '5' },
      { name: 'Class 6', code: '6' },
      { name: 'Class 7', code: '7' },
      { name: 'Class 8', code: '8' },
    ],
    vehicleDropdownData: {},
    loadingDropdown: false,
    freightData: [],
    serviceData: [],
    nonRoadData: [],
    passengerData: [],
    classesForVehicles: {},
    showDashboardModal: true,
  },
  getters: {
    getAllVehicleVocations: (state) => state.vehicleVocations,
    getAllVehicleClasses: (state) => state.vehicleClasses,
    getVehicleTypes: (state) => state.vehicleTypes,
    getSelectedVocation: (state, getters, rootState) => {
      if (
        rootState.route.query
        && rootState.route.query.vocation !== undefined
      ) {
        return rootState.route.query.vocation;
      }
      return ['all'];
    },
    getSelectedClass: (state, getters, rootState) => {
      if (
        rootState.route.query
          && rootState.route.query.class !== undefined
      ) {
        return rootState.route.query.class;
      }
      return ['all'];
    },
    getAllClassesForVehicles: (state) => state.classesForVehicles,
    getApiFilters: (state, getters) => {
      const apiQueryParams = {
        vocation_id: clone(getters.getSelectedVocation),
        weight_class: clone(getters.getSelectedClass),
      };
      // delete all values since the api call does not need a value to choose all
      Object.keys(apiQueryParams).forEach((param) => {
        const index = apiQueryParams[param].indexOf('all');
        if (index > -1) {
          apiQueryParams[param].splice(index, 1);
        }
      });
      return apiQueryParams;
    },
    getVehicleDropdown: (state) => state.vehicleDropdownData,
    getLoadingDropdown: (state) => state.loadingDropdown,
    getMilesTreeMap: (state) => state.milesTreeMap,
    getFreightData: (state) => state.freightData,
    getServiceData: (state) => state.serviceData,
    getNonRoadData: (state) => state.nonRoadData,
    getPassengerData: (state) => state.passengerData,
    getShowDashboardModal: (state) => state.showDashboardModal,
    getSelectedVocationObject: (state, getters) => {
      const vocationIdArray = getters.getSelectedVocation;
      const vocationArray = typeof vocationIdArray === 'string'
        ? [vocationIdArray]
        : vocationIdArray;
      const allVocations = getters.getAllVehicleVocations;
      const selectedArr = [];
      vocationArray.forEach((vocationId) => {
        allVocations.forEach((vocation) => {
          if (vocationId === vocation.code) {
            selectedArr.push(vocation);
          }
        });
      });
      return selectedArr;
    },
    getSelectedClassObject: (state, getters) => {
      const classIdArray = getters.getSelectedClass;
      const classArray = typeof classIdArray === 'string' ? [classIdArray] : classIdArray;
      const allClasses = getters.getAllVehicleClasses;
      const selectedArr = [];
      classArray.forEach((classId) => {
        allClasses.forEach((classType) => {
          if (classId === classType.code) {
            selectedArr.push(classType);
          }
        });
      });

      return selectedArr;
    },
  },
  mutations: {
    setVehicleChartData(state, vehicleData) {
      const milesByVocation = vehicleData.reduce((obj, vehicle) => {
        if (obj[vehicle.h_vocation]) {
          obj[vehicle.h_vocation] += parseInt(vehicle.miles);
        } else {
          obj[vehicle.h_vocation] = parseInt(vehicle.miles);
        }
        return obj;
      }, {});

      const milesArray = [];
      Object.keys(milesByVocation).forEach((milesObj) => {
        milesArray.push({
          name: milesObj,
          value: milesByVocation[milesObj],
        });
      });

      milesArray.sort((a, b) => b.value - a.value);

      const freightCategories = [
        'Freight',
        'Freight-Local',
        'Freight-Long Haul',
        'Freight-Regional',
      ];
      const serviceCategories = [
        'Service-Construction',
        'Service-Road Maint',
        'Service-Sanitation',
        'Service-Utility',
      ];
      const nonRoadCategories = ['Nonroad-CHE', 'Nonroad-Airport'];
      const passengerCategories = [
        'Passenger-School',
        'Passenger-Shuttle',
        'Passenger-Transit',
      ];

      const freightData = [];

      const serviceData = [];
      const nonRoadData = [];
      const passengerData = [];

      milesArray.forEach((vehicle) => {
        if (freightCategories.includes(vehicle.name)) {
          freightData.push(vehicle);
        } else if (serviceCategories.includes(vehicle.name)) {
          serviceData.push(vehicle);
        } else if (nonRoadCategories.includes(vehicle.name)) {
          nonRoadData.push(vehicle);
        } else if (passengerCategories.includes(vehicle.name)) {
          passengerData.push(vehicle);
        }
      });
      state.freightData = freightData;
      state.serviceData = serviceData;
      state.nonRoadData = nonRoadData;
      state.passengerData = passengerData;
    },

    setVehicleDropdowns(state, vehicleData) {
      const classNames = {
        all: 'All Classes',
        '-1': 'Unknown',
        1: 'Class 1',
        2: 'Class 2',
        3: 'Class 3',
        4: 'Class 4',
        5: 'Class 5',
        6: 'Class 6',
        7: 'Class 7',
        8: 'Class 8',
      };

      const allClasses = { all: state.vehicleClasses };

      const data = vehicleData.result;
      const vehicleObj = data.reduce((obj, vehicle) => {
        if (obj[vehicle.h_vocation_id]) {
          obj[vehicle.h_vocation_id].weight_class.push(vehicle.weight_class);
        } else {
          const newObj = {};
          newObj.name = vehicle.h_vocation;
          newObj.vocation_id = vehicle.h_vocation_id;
          newObj.weight_class = ['all', vehicle.weight_class];
          obj[vehicle.h_vocation_id] = newObj;
        }
        return obj;
      }, {});

      const vehicleObjTest = data.reduce((obj, vehicle) => {
        if (obj[vehicle.h_vocation_id]) {
          obj[vehicle.h_vocation_id].push({
            name: classNames[vehicle.weight_class],
            code: vehicle.weight_class,
          });
        } else {
          obj[vehicle.h_vocation_id] = [
            { name: 'All Classes', code: 'all' },
            {
              name: classNames[vehicle.weight_class],
              code: vehicle.weight_class,
            },
          ];
        }
        return obj;
      }, {});

      const objWithAll = { ...allClasses, ...vehicleObjTest };
      state.classesForVehicles = objWithAll;
      state.vehicleDropdownData = vehicleObj;
    },
    setLoadingDropdown(state, bool) {
      state.loadingDropdown = bool;
    },
    setDashboardModal(state, bool) {
      state.showDashboardModal = bool;
    },
  },
  actions: {
    async fetchLoadingData({ commit }) {
      commit('setLoadingDropdown', true);
      try {
        const options = {
          headers: {
            'X-Api-Key': import.meta.env.VUE_APP_NREL_API_KEY,
          },
        };
        const response = await Promise.all([
          ky
            .get(
              `${
                import.meta.env.VUE_APP_API_URL_ROOT
              }/v1/available_vehicles.json`,
              options,
            )
            .json(),
          ky
            .get(`${import.meta.env.VUE_APP_API_URL_ROOT}/v1/stats.json`, options)
            .json(),
        ]);
        commit('setVehicleDropdowns', response[0]);
        commit('setVehicleChartData', response[1].result.miles_per_vocation);
      } catch (e) {
        commit('setLoadingDropdown', false);
        // eslint-disable-next-line no-console
        console.log(e);
      } finally {
        commit('setLoadingDropdown', false);
      }
    },
  },
};
